import { ECustomerType } from '@aqx-core/common/api/account';
import { TAppLanguageISOCountryCode, i18n } from '@aqx-core/common/i18n';

export const mapCustomerTypeLabelToText = (orderTypeLabel: ECustomerType, lng?: TAppLanguageISOCountryCode) => {
  const CUSTOMER_TYPE_LABEL_TEXT_MAP: Record<ECustomerType, () => string> = {
    [ECustomerType.CORPORATE]: () => i18n.t('Corporate', { lng }),
    [ECustomerType.INDIVIDUAL]: () => i18n.t('Individual', { lng })
  };
  return CUSTOMER_TYPE_LABEL_TEXT_MAP[orderTypeLabel]();
};
